import React from 'react';
import LogoWhite  from './xlcrmai-logo-light.svg';
import LogoBlack from './xlcrm-ai-logo.svg';

type LogoProps = {
    theme?: 'light' | 'dark',
    width?: string | number;
    height?: string | number;
}

const XLLogo: React.FC<LogoProps> = ({ theme, width, height }) => {

    return theme == 'light' ? <img src={LogoWhite} width={width} height={height} /> : <img src={LogoBlack} width={width} height={height} />;
}
XLLogo.defaultProps = {
    theme: 'light',
    height: 100
}
export default XLLogo;